import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { LzFeedbackComponent } from '../components/feedback/lz-feedback.component';

@Injectable()

export class LzFeedbackService {

  private lzFeedbackDialogOptions: any = {
    panelClass: 'lz-feedback-modal-form',
    autoFocus: false
  };

  //noinspection JSAnnotator
  private lzFeedbackDialogRef: MatDialogRef < LzFeedbackComponent > ;

  constructor(public dialog: MatDialog) {

  }

  openFeedbackDialog(afterCloseCallback?): void {
    this.lzFeedbackDialogRef = this.dialog.open(LzFeedbackComponent, this.lzFeedbackDialogOptions);
    if (afterCloseCallback) {
      this.lzFeedbackDialogRef.afterClosed().subscribe(() => {
        afterCloseCallback();
      });
    }
  }

}
